import { Depot, Instance, Objekt, Promize, Table } from '@siposdani87/sui-js';
import { initTable } from '@utils/collectionSetup';
import { app } from '../app';
import { IndividualHuntService } from '@services/individualHuntService';
import { ReportService } from '@services/reportService';
import { DashboardController } from './dashboardController';

export class ReportsBuildingsWhoTheyHuntController extends DashboardController {
    static readonly inject = [
        'instances',
        'reportService',
        'individualHuntService',
    ] as const;

    localDepot: Depot;
    individualHuntsTable!: Table;

    constructor(
        instances: Instance,
        private reportService: ReportService,
        private individualHuntService: IndividualHuntService,
    ) {
        super(instances);

        this.localDepot = instances.localDepot;
    }

    protected override _initLayout(): void {
        this._initToolbarButtons();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initHuntTable();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-reports-index', this.dom, () => {
            this.state.goBack('reports.index');
        });

        this.helper.fabButton('.btn-reports-filter', this.dom, () => {
            this.reportService.detailsDialog('buildings');
        });
    }

    private _initHuntTable(): void {
        this.individualHuntsTable = initTable(
            this.individualHuntsTable,
            this.dom,
            '.individual-hunts-table',
            this.individualHuntService,
            {
                entityKey: 'hunts',
                fetchData: (params) => {
                    const buildingsReport = new Objekt(
                        this.localDepot.get(
                            this.reportService.getStorageKeyReport('buildings'),
                        ),
                    );
                    return this.reportService.getAllByBuildings(
                        buildingsReport,
                        params,
                    );
                },
            },
        )!;
    }
}

export const reportsBuildingsWhoTheyHuntController = app.controller(
    'reportsBuildingsWhoTheyHuntController',
    ReportsBuildingsWhoTheyHuntController,
);
